export enum MimeTypes {
  Image = 1,
  Video = 2,
  Audio = 3,
  Compressed = 4,
  Word = 5,
  PresentationAndPowerpoint = 6,
  ExcelAndSheet = 7,
  Pdf = 8,
  Html = 9,
  Text = 10,
  Exe = 11,
  Unknown = 12
}
